import type { ReactNode } from "react";

interface IconProps {
  children: ReactNode;
  hoverState?: boolean;
  visible?: boolean;
}

export default function Icon({ children, hoverState, visible }: IconProps) {
  return (
    <div
      className={
        "mb-8 inline-flex rounded-full bg-[#007BB30A] p-5" +
        (hoverState ? " ripple hover:bg-[#007BB31F]" : "") +
        (visible === false ? " opacity-40" : "")
      }
    >
      {children}
    </div>
  );
}
